module.exports = __webpack_public_path__ + "5d0f8a61797508c84e9e73b168e96a54.png";